import { CLOSE_MEDIA, SHOW_MEDIA } from "./mediaView.constant";



export const showMediaAction = (
  payload // {type:video or image, src: url, title:string}
) => ({ type: SHOW_MEDIA, payload })

export const closeMediaAciton = () => ({ type: CLOSE_MEDIA })